import { Image } from '@packages/shared/src/ui/Image/Image';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useCookies } from '@packages/shared/src/providers/CookieProvider/CookieProvider';
import { useIntl } from 'react-intl';
import { Link } from '@packages/modules/src/Link/Link';
import { messages } from './messages';

const Seal = ({
  link,
  imageSrc,
  alt,
  ariaLabel,
}: {
  link: string;
  imageSrc: string;
  alt: string;
  ariaLabel: string;
}) => (
  <Link href={link} aria-label={ariaLabel} openInNewTab>
    <Image src={imageSrc} alt={alt} width={75} height={75} unoptimized />
  </Link>
);

export const Seals = () => {
  const {
    order: { seals, assets: images },
  } = useConfig();
  const { getCookies } = useCookies();
  const { appView } = getCookies();

  const { locale, formatMessage } = useIntl();
  const language = locale.split('-')[0];

  if (appView === 'true') {
    return null;
  }

  return (
    <div className="bg-color-common-white flex w-full flex-wrap gap-2 px-2 py-2 md:px-0">
      {seals.trustedShops.enabled && (
        <Seal
          link={seals.trustedShops.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'trustedShops' })}
          alt="trustedShops"
          ariaLabel={formatMessage(messages.trustedShopsAriaLabel)}
        />
      )}
      {seals.ehi.enabled && (
        <Seal
          link={seals.ehi.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'ehi' })}
          alt="ehi"
          ariaLabel={formatMessage(messages.ehiAriaLabel)}
        />
      )}
      {seals.staatswappen.enabled && (
        <Seal
          link={seals.staatswappen.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'staatswappen' })}
          alt="staatswappen"
          ariaLabel={formatMessage(messages.staatswappenAriaLabel)}
        />
      )}
      {seals.handelsverband.enabled && (
        <Seal
          link={seals.handelsverband.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'handelsverband' })}
          alt="handelsverband"
          ariaLabel={formatMessage(messages.handelsverbandAriaLabel)}
        />
      )}
      {seals.ecommerce.enabled && (
        <Seal
          link={seals.ecommerce.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'ecommerce' })}
          alt="ecommerce"
          ariaLabel={formatMessage(messages.oeonlineAriaLabel)}
        />
      )}
      {seals.oeonline.enabled && (
        <Seal
          link={seals.oeonline.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'oeonline' })}
          alt="oeonline"
          ariaLabel={formatMessage(messages.oeonlineAriaLabel)}
        />
      )}
      {seals.dqs.enabled && (
        <Seal
          link={seals.dqs.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'dqs' })}
          alt="dqs"
          ariaLabel={formatMessage(messages.oeonlineAriaLabel)}
        />
      )}
    </div>
  );
};
